<template lang="pug">
.RankBadge(
  :class=`{
    horizontal: layout === 'horizontal',
    vertical: layout === 'vertical'
  }`
)
  .badge(
    :style='{ backgroundColor: color, width: `${size}px`, height: `${size}px`}'
    @click="handleClick"
  )
    img.badgeImage(v-if="rankIndex === 0" src="@/assets/badge_1.png")
    img.badgeImage(v-if="rankIndex === 1" src="@/assets/badge_2.png")
    img.badgeImage(v-if="rankIndex === 2" src="@/assets/badge_3.png")
    img.badgeImage(v-if="rankIndex === 3" src="@/assets/badge_4.png")
    img.badgeImage(v-if="rankIndex === 4" src="@/assets/badge_5.png")
    img.badgeImage(v-if="rankIndex === 5" src="@/assets/badge_6.png")
    img.badgeImage(v-if="rankIndex === 6" src="@/assets/badge_7.png")
    img.badgeImage(v-if="rankIndex === 7" src="@/assets/badge_8.png")
    img.badgeImage(v-if="rankIndex === 8" src="@/assets/badge_9.png")
  .label(v-if="labelEnabled") {{ rankName }}
</template>

<script>
// import { mapState, mapActions } from 'vuex'
import challengeService from '@/services/ChallengeService'

export default {
  name: 'km-rank-badge',
  components: {},
  props: {
    score: {
      type: Number
    },
    labelEnabled: {
      type: Boolean
    },
    layout: {
      type: String,
      default: 'vertical' // or horizontal
    },
    size: {
      type: Number
    }
  },
  data() {
    return {
      rankIndex: 0,
      rankName: ''
    }
  },
  computed: {
    // rankColor: function() {},
    color: function() {
      let rankColor
      switch (this.rankIndex) {
        case 0:
          rankColor = 'gray'
          break
        case 1:
          rankColor = 'gray'
          break
        case 2:
          rankColor = 'gray'
          break
        case 3:
          rankColor = 'silver'
          break
        case 4:
          rankColor = 'silver'
          break
        case 5:
          rankColor = 'silver'
          break
        case 6:
          rankColor = 'gold'
          break
        case 7:
          rankColor = 'gold'
          break
        case 8:
          rankColor = 'gold'
          break
      }
      return `${rankColor}`
    }
  },
  watch: {
    score() {
      this.rankIndex = challengeService.getRank(this.score)
      this.rankName = challengeService.getRankName(this.rankIndex)
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  },
  mounted() {
    this.rankIndex = challengeService.getRank(this.score)
    this.rankName = challengeService.getRankName(this.rankIndex)
  }
}
</script>

<style lang="scss" scoped>
.RankBadge {
  display: inline-block;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  text-align: center;

  &.horizontal {
    display: inline-flex;
    flex-direction: row;
    .badge {
      flex-direction: row;
    }
  }

  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 50%;

    .badgeImage {
      // max-width: 78%;
      max-height: 85%;
      // width: 100%;
    }
  }

  .label {
    margin: 10px 0 0 0;
  }
}
</style>
